/**
* @name: formulaValCell
* @author: weiyong
* @date: 2024-01-16 13:44
* @description：formulaValCell
* @update: 2024-01-16 13:44
*/
<template>
  <div class="formulaValCell">
      {{showCell}}
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "formulaValCell",
});
</script>

<script lang="ts" setup>

interface IProps {
  record: any,
  column: any,
  index:any,
  cellContent: any,
}

const props = withDefaults(defineProps<IProps>(), {
  record: {},
  column: {},
  index:{},
  cellContent: null,
})
const {column,cellContent,record}=toRefs(props);

const getFunContent = function (pArgItem){
  const {args,title}=pArgItem;
  const argValues:any=[];
  args.forEach((argItem)=>{
    if(argItem.type==="field"){
      argValues.push(unref(record)[argItem.value]);
    }
    if(argItem.type==="fun"){
      argValues.push(getFunContent(argItem));
    }
  });
  switch (title){
    case 'CONCATENATE':
      return argValues.join("/");
      break;
    case 'SUB':
      return parseFloat(argValues[0])-parseFloat(argValues[1]);
      break;
    default:
      return ''
  }
}
const showCell=ref('');
const {cellShowContent}=unref(column);
if(cellShowContent[0]&&cellShowContent[0].args){
  showCell.value= getFunContent(cellShowContent[0]);
}
</script>

<style type="text/css" lang="less">

</style>
